<template>
  <div id="selectModule" class="d-flex">
       <!-- <div class="header-top">
      <div class="container-fluid">
        <HeadingUser />
      </div>
    </div> -->
    <div class="layout-content container-fluid ">
      <HeadingUser />   
      <div class="row mt-5">
        <div class="col-xs-12 col-md-8 col-lg-8 mx-auto">
          <div v-if="loadingOn" id="loader"></div>
          <div v-else class="cont-carousel">
            <div class="d-flex mt-5">
              <button  class="card shadow p-3 m-3 d-block" @click="changeModule(1)">
                <div class="d-flex col-12 p-0 align-items-center m-1">
                  <img src="@/assets/images/icons/flight.svg" width="10%" class="mr-2"/>
                  <h3 class="p-0">Virtual Partner 1.0</h3>
                </div>
                <p class="col-12 p-0">Derechos de petición y Permisos sindicales.</p>
              </button>
              <button class="card shadow p-3 m-3 d-block" @click="changeModule(2)">
                <div class="d-flex col-12 p-0 align-items-center m-1">
                  <img src="@/assets/images/icons/stethoscope.svg" width="10%" class="mr-2"/>
                  <h3 class="p-0">Health Tracker</h3>
                </div>
                <p class="col-12 p-0">Controla y consulta procesos de salud.</p>
              </button>
            </div>
            <b-carousel
              id="carousel-1"
              v-model="slide"
              :interval="5000"
              controls
              indicators
              background="#fffff"
              img-width="1024"
              img-height="480"
              style="text-shadow: #00000;"
              @sliding-start="onSlideStart"
              @sliding-end="onSlideEnd"              
            >
              <b-carousel-slide img-blank v-for="(data, index) in onboardingData" :key="data.id">
                <div class="row">
                  <div class="col-xs-12 col-lg-6 col-xl-6 text-center">                    
                    <img
                      width="250"
                      height="300"
                      :src="serverPath+'/'+data.image"
                      alt="user print"
                      class="mb-0 mb-md-0"
                    />
                  </div>
                  <div class="col-xs-12 col-lg-6 col-xl-6">
                    <h2 class="mb-5">{{data.title}}</h2>
                    <p class="p2" style="">{{data.text}}</p>
                    <div v-if="index+1 == onboardingData.length && user.core_role_id != 6" class="mt-3 mt-md-5 mb-3" align="right">
                      <router-link to="/solicitudes" class="btn-darkblue-1 px-5 py-2">Empezar</router-link>
                    </div>
                    <div v-if="index+1 == onboardingData.length && user.core_role_id == 6" class="mt-3 mt-md-5 mb-3" align="right">
                      <router-link to="/settle" class="btn-darkblue-1 px-5 py-2">Empezar</router-link>
                    </div>
                  </div>
                </div>
              </b-carousel-slide>
            </b-carousel>
          </div>
        </div>
        <ComingSoon v-if="validModule('health-tracker')"/>
        <!-- .col -->
      </div>
      <!-- .row -->
    </div>
    <!-- .layout-content -->
  </div>
  <!-- #page-onboarding -->
</template>

<script>
import HeadingUser from "@/components/user/HeadingUser.vue";
import { mapActions, mapState } from "vuex";
import ComingSoon from "../../components/healthTracker/comingSoon.vue"
import serverConfig from "./../../services/config";

export default {
  name: "HomeOnBoarding",
  components: {
    HeadingUser,
    ComingSoon
  },
  data() {
    return {
      serverPath: serverConfig.permisosURL,
      error: {
        flag: false,
        class: "", //is-valid
        message: "",
      },
      success: {
        flag: false,
        class: "", //is-invalid
        message: "",
      },
      slide: 0,
      sliding: null,
      onboardingData: [],      
    };
  },
  created() {
    this.actUser();
  },
  beforeMount() {      
    this.actGetOnboarding().then(() =>{
                   this.onboardingData = this.onboarding.data;
                })
                .catch((response) => {
                  this.error.flag = true;
                  this.error.class = "is-invalid";
                  this.error.message = "No se pudo conectar al servicio: error: "+response;
                });
  },

  computed: {    
    ...mapState("modCore", [
      "user",
      "onboarding",
      "loadingOn",
    ]),
  },

  methods: {
    ...mapActions("modCore", [
      "actGetOnboarding",
       "actUser",
       "actModule"
    ]),
    
    onSlideStart() {
      this.sliding = true
    },
    onSlideEnd() {
      this.sliding = false
    },
    changeModule(x){
      if(x ==  1){
        this.actModule('Virtual Partner 1.0')
        this.$router.push({ path: "/solicitudes" }); 
      }else if (x ==  2){
        this.actModule('Health Tracker')
        this.$router.push({ path: "/employee" }); 
      }
    }
  },
};
</script>

<style lang="scss">
/** Carousel */
#selectModule {
  .cont-carousel {
    /*height: calc(100vh - 70px);
    padding-top: 50px;
    margin-bottom: 70px;

    @media (min-width: 768px) {
      padding-top: calc(50% - 300px);
    }

    @media (min-width: 992px) {
      padding-top: calc(50% - 150px);
    }

    @media (min-width: 1200px) {
      padding-top: calc(50% - 300px);
    }*/

    .carousel-control-next-icon,
    .carousel-control-prev-icon,
    .carousel-indicators {
      filter: invert(1);
    }
  }

  .p2 {
    font-family: "Open Sans";
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #1C3A4E;
    padding-left: 5%;
    text-align: justify;
  }

  #loader {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 1;
    width: 150px;
    height: 150px;
    margin: 150px 0 0 -75px;
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }

  @-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  /* Add animation to "page content" */
  .animate-bottom {
    position: relative;
    -webkit-animation-name: animatebottom;
    -webkit-animation-duration: 1s;
    animation-name: animatebottom;
    animation-duration: 1s
  }

  @-webkit-keyframes animatebottom {
    from { bottom:-100px; opacity:0 } 
    to { bottom:0px; opacity:1 }
  }

  @keyframes animatebottom { 
    from{ bottom:-100px; opacity:0 } 
    to{ bottom:0; opacity:1 }
  }

  #myDiv {
    display: none;
    text-align: center;
  }
  .card {
    font-family: Poppins;
    border-radius: 15px;
    color: black;
    h3{
      font-size: 16;
      font-weight: 500;
    }
    p{
      font-size: 10px;
    }
  }
}
</style>